<template>
  <v-card v-if="order" flat class="mt-4" >
      <v-row>
        <v-card-title class="ml-3"> Objednávka {{ order.code }} </v-card-title>
      </v-row>


    <v-divider class="mx-4"></v-divider>
    <v-card-text class="py-0">

      <span v-if="order.state ===  'nová'">Stav objednávky: <strong class="warning--text">{{ order.state }}</strong></span>
      <span v-if="order.state ===  'schválená'">Stav objednávky: <strong class="success--text">potvrdená</strong></span>
      <span v-if="order.state ===  'ukončená'">Stav objednávky: <strong class="info--text">{{ order.state }}</strong></span>
      <span v-if="order.state ===  'zamietnutá'">Stav objednávky: <strong class="info--text">{{ order.state }}</strong></span>

        <v-container class="py-0 mb-n8">
          <v-row justify="start">
            <v-col cols="6" sm="6" lg="3" md="3">
              <v-text-field
              class="subtitle-2 text-center"
                label="Dátum"
                readonly
                :value='this.getEuroDate(order.date)'
              > 
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" lg="3" md="3">
              <v-text-field
              class="subtitle-2 text-center"
                label="Čas"
                readonly 
                :value='(order.term).substring(0,5)'
              > 
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" lg="3" md="3">
               <v-text-field 
               class="subtitle-2 text-center"
                label="Miesto"
                readonly
                :value='order.building + " - " + order.block + ", " + order.flatId'
              > 
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" lg="3" md="3">
              <v-text-field class="subtitle-2 text-center"
                label="Cena/hod."
                readonly
                :value='order.choosePerson.price + " €"'
              > 
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </v-card-text>
    <v-card-actions class="py-0">
      <v-container class="py-0">
      <v-row justify="end" class="py-1">
        <v-col cols="3" class="pa-0 mx-4 justify-end d-flex">
          <v-btn :small="$vuetify.breakpoint.smAndDown" outlined @click="show = !show" class="no-border">
            <span class="accent--text">{{ show ? "Menej" : "Viac" }}</span>
            <v-icon class="accent--text">{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      </v-container>
      <v-spacer></v-spacer>
    </v-card-actions>

    <v-expand-transition>
         <v-row v-show="show" justify="center">
            <v-col cols="4" sm="4" lg="2" md="2">
              <v-text-field
              class="subtitle-2 text-center"
                label="Typ upratovania"
                readonly
                :value='order.cleaningType'
              > 
              </v-text-field>
            </v-col>
            <v-col cols="7" sm="7" lg="4" md="4">
              <v-text-field
              class="subtitle-2 text-center"
                label="Upratovač/ka"
                readonly
                :value='order.choosePerson.name + " " + order.choosePerson.surname'
              > 
              </v-text-field>
            </v-col>
            <v-col 
              cols="11" 
              sm="11" 
              lg="5" 
              md="5"
           >
               <v-text-field
                class="subtitle-2 text-center"
                label="E-mail"
                readonly
                :value='order.userInfo.email'
              > 
              </v-text-field>
            </v-col>
            <v-col class="text-left" v-if="order.note" cols="11">
              <v-textarea
                class="subtitle-2 text-center"
                label="Poznámka"
                auto-grow
                rows="1"
                readonly
                :value='order.note'
              > 
              </v-textarea>
            </v-col>
             <v-col class="text-left my-n4" v-if="review" cols="11">
               <v-divider class="mb-4" color="success"></v-divider>
              <v-textarea
                class="subtitle-2 text-center"
                auto-grow
                rows="1"
                label="Recenzia"
                readonly
                :value='review'
              > 
              </v-textarea>
            </v-col>
            <v-col v-if="rating" class="ml-5 my-0">
              <v-rating
                :value='rating'
                empty-icon="mdi-star-outline"
                full-icon="mdi-star"
                length="5"
                size="20"
                readonly
                ></v-rating>
            </v-col>
          </v-row>
    </v-expand-transition>
  </v-card>
</template>


<script>
import axios from 'axios';
import store from "../../store/store";

export default {
  name: "order",
  data: () => ({
    show: false,
    feedbackDialog: false,
    review: null,
    rating: null,
    alreadyReviewed: false
  }),
  methods: {
    setFeedback(review) {
      this.review = review.feedbackNote
      this.rating = review.rating
      this.alreadyReviewed = true
    },
    getEuroDate(date) {
      var myDate = new Date(date);
        return (
            ("0" + myDate.getDate()).slice(-2) + "." + ("0" + (myDate.getMonth() + 1)).slice(-2)  + "." + myDate.getFullYear()
        );
    },
    getReviewToOrder(orderCode){
          axios.get(store.state.url.concat('getReviewToOrder.php'), {
              params: {
                  orderCode:  orderCode
              }
          }).then((response) => {
              if(response.data.result == 'ok'){
                  this.alreadyReviewed = true;
                  this.review = response.data.review
                  this.rating = parseInt(response.data.rating)
                  this.$emit('alreadyReviewed');
              }else{
                  this.alreadyReviewed = false;
                  this.$emit('alreadyReviewed');
              }

          });
          return this.alreadyReviewed;
      }
  },
  created: function() {
    this.getReviewToOrder(this.order.code)
  },
  props: ["order"]
};
</script>